module.exports = __webpack_public_path__ + "img/1.4052ede1.svg";